import { useEffect, useState } from "react";

const preloaderSrc = `${process.env.PUBLIC_URL || ""}/assets/images/icon/preloader.gif`;

const Preloader = () => {
  let [active, setActive] = useState(true);
  useEffect(() => {
    setTimeout(function () {
      setActive(false);
    }, 500);
  }, []);

  return (
    <>
      {active ? (
        <div className="preloader">
          <img src={preloaderSrc} alt="Loading RGHT NOW" />
        </div>

      ) : (<div></div>)}
    </>
  );
};

export default Preloader;
